<template>
    <div v-if="show" class="modal-overlay" @click.self="$emit('close')">
        <form class="modal-container" @submit.prevent="handleSubmit">
            <div class="modal-header">
                <h4 class="p-0 m-0">Ajouter un nouveau rendez-vous</h4>
                <button type="button" class="close-button" @click="$emit('close')">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="form-group">
                        <label for="appointment-day">Jour</label>
                        <input type="text" class="form-control" id="appointment-day" v-model="localAppointment.day" readonly>
                    </div>
                    <div class="form-group">
                        <label for="appointment-start-time">Heure de début</label>
                        <input type="time" class="form-control" id="appointment-start-time" v-model="localAppointment.start_time">
                    </div>
                    <div class="form-group">
                        <label for="appointment-end-time">Heure de fin</label>
                        <input type="time" class="form-control" id="appointment-end-time" v-model="localAppointment.end_time">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="$emit('close')">Annuler</button>
                <button type="submit" class="btn btn-blue">Ajouter</button>
            </div>
        </form>
    </div>
</template>

<script>
import timeMixin from "../../Mixins/appointmentsMixin";

export default {
    name: "NewAppointmentModal",
    mixins: [timeMixin],
    props: {
        show: {
            type: Boolean,
            default: false
        },
        appointment: {
            type: Object,
            default: () => ({
                day: '',
                start_time: '',
                end_time: ''
            })
        }
    },
    data() {
        return {
            localAppointment: {
                day: this.appointment.day,
                start_time: this.appointment.start_time,
                end_time: this.appointment.end_time
            }
        }
    },
    watch: {
        appointment: {
            handler(newVal) {
                this.localAppointment = { ...newVal };
            },
            deep: true
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('submit', {
                day: this.localAppointment.day,
                start_time: this.localAppointment.start_time,
                end_time: this.localAppointment.end_time
            });
        }
    }
}
</script>
